import { NavLink } from "react-router-dom";
import { Home, ReceiptText, Box } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Home", icon: Home, end: true, testid: "bottom-nav-home" },
  { to: "/transaksi", label: "Transaksi Saya", icon: ReceiptText, testid: "bottom-nav-transaksi" },
  { to: "/bongkar", label: "Bongkar", icon: Box, testid: "bottom-nav-bongkar" },
];

export const BottomNav = () => (
  <nav
    className="fixed inset-x-0 bottom-0 z-50 border-t border-[#2a2414] bg-[#0b0b0b]/95 backdrop-blur"
    data-testid="bottom-nav"
  >
    <div className="mx-auto grid max-w-md grid-cols-3 gap-2 px-3 py-2">
      {ITEMS.map(({ to, label, icon: Icon, end, testid }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          data-testid={testid}
          className={({ isActive }) =>
            `flex flex-col items-center justify-center gap-1 rounded-2xl py-2 text-[11px] font-bold transition-colors ${
              isActive ? "kz-gold-btn text-black" : "text-[#e8d9a8] hover:text-white"
            }`
          }
        >
          <Icon size={18} strokeWidth={2.4} />
          {label}
        </NavLink>
      ))}
    </div>
  </nav>
);
